import React from "react";
import Logo from "./assets/logo.svg";
import TwitterIcon from "./assets/logo-twitter.svg";
import FbIcon from "./assets/logo-fb-simple.svg";
import LinkdenIcon from "./assets/logo-linkden.svg";
import GithubIcon from "./assets/logo-github.svg";


const Footer = () => {
  const navLinks = [
    { name: "Home", link: "/" },
    { name: "Sandbox", link: "/sandbox-intro" },
    { name: "Contact", link: "/contact-us/?reason=other" },
    { name: "Free Trial", link: "/freetrial" },
    { name: "Request a Demo", link: "/contact-us/?reason=demo" },
  ];

  return (
    <footer className="bg-[#131A22] px-4 pt-[120px] pb-7 md:pb-[90px]">
      <div className="max-w-[1200px] w-full mx-auto">
        <div className="flex items-start lg:items-center justify-between flex-col lg:flex-row gap-9 lg:gap-4 mb-14">
          <div>
            <a href="/">
              <img
                src={Logo}
                alt="Obics Logo"
                className="h-10 md:h-[50px] "
              />
            </a>
          </div>

          {/* Mobile Menu Links */}
          <ul className="flex items-center flex-wrap gap-y-8 gap-x-14">
            {navLinks.map((link, index) => (
              <li key={index}>
                <a
                  href={link.link}
                  className="text-light1 text-lg font-normal transition-all duration-300 hover:text-[#4558C1] hover:underline"
                >
                  {link.name}
                </a>
              </li>
            ))}
          </ul>

          {/* Footer Section with Social Icons */}
          <div className="flex justify-center gap-6 " >
            <a href="https://x.com/Ron__Miller" target="_blank" rel="noopener noreferrer"
               className="h-8 w-8 rounded-full flex items-center justify-center border border-[#D4D4D8] hover:bg-orange1 hover:border-[#FF8039] transition-colors duration-300"
            >
              <img src={TwitterIcon} alt="Twitter" className="w-[11.17px] h-[9.3px]"  />
            </a >

            {/* <span
              className="h-8 w-8 rounded-full flex items-center justify-center border border-[#D4D4D8] hover:bg-orange1 hover:border-[#FF8039] transition-colors duration-300"
            >
              <img src={FbIcon} alt="Facebook" className="w-[6.32px] h-[12.17px]" />
            </span> */}

            <a href="https://www.linkedin.com/in/ron-miller-576328343/" target="_blank" rel="noopener noreferrer"
              className="h-8 w-8 rounded-full flex items-center justify-center border border-[#D4D4D8] hover:bg-orange1 hover:border-[#FF8039] transition-colors duration-300"
            >
              <img src={LinkdenIcon} alt="LinkedIn" className="w-[13.5px] h-[13.5px]" />
            </a >

            {/* <span
              className="h-8 w-8 rounded-full flex items-center justify-center border border-[#D4D4D8] hover:bg-orange1 hover:border-[#FF8039] transition-colors duration-300"
            >
              <img src={GithubIcon} alt="GitHub" className="w-[13px] h-[13px]" />
            </span> */}
          </div>
        </div>

        <div className="flex items-start lg:items-center flex-col lg:flex-row justify-between gap-6">
            <p className="text-white text-sm opacity-70 order-2 lg:order-1">©{new Date().getFullYear()} All rights reserved.</p>

            <div className="flex items-center gap-12 order-1 lg:order-2 opacity-0">
                <a href="#" className="text-sm text-white opacity-70 hover:opacity-100 transition-colors duration-300">Privacy Policy</a>
                <a href="#" className="text-sm text-white opacity-70 hover:opacity-100 transition-colors duration-300">Terms of Use</a>
            </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
